import React, { useState } from "react";
import styles from "./styles.module.scss";
// Components
import Page from "../../Components/Page";
import DashboardSearch from "../../Components/DashboardSearch";
import DashboardHeader from "../../Components/DashboardHeader";
import DashboardNotificationsSection from "../../Components/DashboardNotificationsSection";
// Utils
import {
  getIsUserHasOnlyUserRole,
  getIsUserJustAnInstaller,
} from "../../Services/Utils";
import { useAppSelector } from "State/hooks";
import { useUserFilter } from "../../Services/Hooks/useUserFilter";
import { UserFilterProvider } from "./UserFilterContext";

const Dashboard = () => {
  const user = useAppSelector((state) => state.user.authData);
  const userRoles = user?.roles;
  const userIsJustAnInstaller = getIsUserJustAnInstaller(userRoles);

  const { selectedFilter, setUserFilter } = useUserFilter(userIsJustAnInstaller);

  // Tabs note: when notifications are selected, onClick updates the URL
  // Tabs note: when clicking "awaiting installation" -> this goes to "residents" and updates the filter
  const [selectedTab, setSelectedTab] = useState("residents"); // other options: staff, reports

  // for New residents who have created an account with SSO, they will only have the user role. We should only show the holding screen to them
  const onlyUserRole = getIsUserHasOnlyUserRole(userRoles);

  const noHubsAssigned = user?.hubs?.length === 0;

  return (
    <Page className={styles.page}>
      <div className={styles.content}>
        <DashboardHeader />
        {onlyUserRole && noHubsAssigned ? (
          <div className={styles.welcome_message_container}>
            <h2 className={styles.welcome_message_title}>Welcome to Lilli!</h2>
            <p>
              You're almost set up! To view resident data, ask your Lilli
              programme manager to assign you a resident. In the meantime, learn
              how to use Lilli in the Community section.
            </p>
          </div>
        ) : (
          <UserFilterProvider value={{ selectedFilter, setUserFilter }}>
            <div className={styles.search_and_notifications_container}>
              <DashboardSearch
                userIsJustAnInstaller={userIsJustAnInstaller}
                setSelectedTab={setSelectedTab}
                selectedTab={selectedTab}
              />
              <DashboardNotificationsSection
                setSelectedTab={setSelectedTab}
              />
            </div>
          </UserFilterProvider>
        )}
      </div>
    </Page>
  );
};

export default Dashboard;
